import React from 'react';
import styles from '../styles/Design_Lab.module.css';

export default function StoryGalleryCard({ project, index, total }) {
    const liveUrl = project.websiteUrl?.trim();

    return (
        <article className={styles.projectCard}>
            <div className={styles.projectMeta}>
                <span>
                    {String(index + 1).padStart(2, '0')}/
                    {String(total).padStart(2, '0')}
                </span>

                <span className={styles.projectCategory}>
                    {project.genre}
                </span>
            </div>

            <div className={styles.projectImageWrap}>
                <img
                    src={project.backgroundImage}
                    alt={project.title}
                    className={styles.projectImage}
                    loading="lazy"
                />
            </div>

            <div className={styles.projectContent}>
                <h2 className={styles.projectTitle}>{project.title}</h2>

                {project.projectIntro && (
                    <p className={styles.projectSummary}>
                        {project.projectIntro}
                    </p>
                )}

                <div className={styles.projectDetails}>
                    {project.genre && (
                        <div className={styles.detailsRow}>
                            <span className={styles.detailsLabel}>Genre</span>
                            <span className={styles.detailsValue}>
                                {project.genre}
                            </span>
                        </div>
                    )}

                    {project.status && (
                        <div className={styles.detailsRow}>
                            <span className={styles.detailsLabel}>Status</span>
                            <span className={styles.detailsValue}>
                                {project.status}
                            </span>
                        </div>
                    )}

                    {project.logline && (
                        <div className={styles.detailsRow}>
                            <span className={styles.detailsLabel}>Logline</span>
                            <span className={styles.detailsValue}>
                                {project.logline}
                            </span>
                        </div>
                    )}

                    {Array.isArray(project.tags) && project.tags.length > 0 && (
                        <div className={styles.detailsRow}>
                            <span className={styles.detailsLabel}>Tags</span>
                            <span className={styles.detailsValue}>
                                {project.tags.join(', ')}
                            </span>
                        </div>
                    )}
                </div>

                {liveUrl && (
                    <a
                        href={liveUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.projectButton}
                    >
                        View Live Site
                    </a>
                )}
            </div>
        </article>
    );
}